import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'services/axios';
import { REPORT } from 'store/serverAPIRoute';
import { fetchZipFile } from 'utils/httpUtil';

export const putReportEnable = createAsyncThunk(
  REPORT.PUT_REPORT(),
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosInstance.put(REPORT.PUT_REPORT(params.pixelId));
      return data.data;
    } catch (e) {
      throw rejectWithValue(e);
    }
  }
);

export const getBilboardBreakDownExcel = (pixelId) =>
  fetchZipFile(REPORT.GET_BILBOARD_EXCEL(pixelId));

export const getPlanScreenDetailReport = (plan_id) =>
  fetchZipFile(REPORT.GET_PLAN_SCREEN_DETAIL_REPORT(plan_id));

// 200 -> { id: { url, fileName, warnings } }, 202 -> still generating; caller handles status
// Overrides the instance's 10 s timeout: the plan access check alone can exceed it
export const getPlanDownload = (planId) =>
  axiosInstance.get(REPORT.GET_PLAN_DOWNLOAD(planId), { timeout: 120000 });

// 200 -> { id: { done } }: done once the job reached a final state; then call getPlanDownload again
export const getPlanDownloadStatus = (planId) =>
  axiosInstance.get(REPORT.GET_PLAN_DOWNLOAD_STATUS(planId));

export const getLiftStudyCumulative = createAsyncThunk(
  REPORT.GET_LIFT_STUDY_CUMULATIVE(),
  async (pixelId, { rejectWithValue }) => {
    try {
      const data = await axiosInstance.get(
        REPORT.GET_LIFT_STUDY_CUMULATIVE(pixelId)
      );
      return data.data.id;
    } catch (e) {
      throw rejectWithValue(e);
    }
  }
);

export const getLiftStudyCreative = createAsyncThunk(
  REPORT.GET_LIFT_STUDY_CREATIVE(),
  async (pixelId, { rejectWithValue }) => {
    try {
      const data = await axiosInstance.get(
        REPORT.GET_LIFT_STUDY_CREATIVE(pixelId)
      );
      return data.data.id;
    } catch (e) {
      throw rejectWithValue(e);
    }
  }
);

export const getLiftStudyMonthly = createAsyncThunk(
  REPORT.GET_LIFT_STUDY_MONTHLY(),
  async (pixelId, { rejectWithValue }) => {
    try {
      const data = await axiosInstance.get(
        REPORT.GET_LIFT_STUDY_MONTHLY(pixelId)
      );
      return data.data.id;
    } catch (e) {
      throw rejectWithValue(e);
    }
  }
);
